<div class="ui-dialog">
    <h4 class="ui-dialog-title ui-title" mat-dialog-title>
        <ng-container *ngIf="type === 'all'">Estas por pagar todas tus facturas pendientes</ng-container>
        <ng-container *ngIf="type === 'custom'">Estas por realizar un pago de $ {{data.amount | number:'1.2-2'}}</ng-container>
    </h4>
    
    <div class="ui-dialog-content" mat-dialog-content>
        <div class="radio-container">
            <label class="radio-label" [ngClass]="{ 'selected': paymentMethod === 'pagos360' }">
              <input type="radio" name="paymentMethod" value="pagos360" (change)="paymentMethod = 'pagos360'" hidden>
              <img src="assets/images/pagos360.png" alt="Pagos360" class="radio-image">
            </label>

            <label class="radio-label" [ngClass]="{ 'selected': paymentMethod === 'mercadopago' }">
              <input type="radio" name="paymentMethod" value="mercadopago" (change)="paymentMethod = 'mercadopago'" hidden>
              <img src="assets/images/mercadopago.png" alt="Mercado Pago">
            </label>
        </div>

        <p *ngIf="isPaymentStatus">
            <mat-checkbox color="primary" [(ngModel)]="cancelUnsuscribe" value="true">Quiero anular la baja de mi cuenta y restablecer el servicio</mat-checkbox>
        </p>
    </div>
    
    <div class="ui-dialog-actions" mat-dialog-actions>
        <button mat-button type="button" (click)="onCancel()">Cancelar</button>
        <button mat-button type="button" color="primary" class="ui-button" [disabled]="!['pagos360', 'mercadopago'].includes(paymentMethod)" (click)="onSend()">Pagar</button>
    </div>
</div>